const title1 = `
  font-size: 26px;
  font-weight: bold;
  line-height: 36px;
  letter-spacing: 0;
`

const title2 = `
  font-size: 20px;
  font-weight: bold;
  line-height: 28px;
  letter-spacing: 0;
`

const title3 = `
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  letter-spacing: 0;
`

const title4 = `
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 0;
`

const description1 = `
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  letter-spacing: 0;
`

const description2 = `
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0;
`

const caption1 = `
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0;
`

const caption2 = `
  font-size: 12px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0;
`

const caption3 = `
  font-size: 11px;
  font-weight: normal;
  line-height: 16px;
  letter-spacing: 0;
`

export interface TypographySet {
  title1: string
  title2: string
  title3: string
  title4: string
  description1: string
  description2: string
  caption1: string
  caption2: string
  caption3: string
}

const typography = {
  title1,
  title2,
  title3,
  title4,
  description1,
  description2,
  caption1,
  caption2,
  caption3,
}

export default typography
